import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'ui-skeleton-chat-copilot',
  standalone: true,
  templateUrl: './skeleton-chat-copilot.component.html',
  imports: [CommonModule]
})
export class UISkeletonChatCopilotComponent {
  public skeletonItems: any[] = Array(4).fill(0);
}
